
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    
    <script src="https://www.youtube.com/iframe_api"></script>
    <script src="../../../../assets/scripts/jquery.min.js"></script>
    <script src="../../../../assets/scripts/script.js"></script>
<title>Studenty-Your social Platform</title>

</head>
<body>




<!--test-->
<div class="row" style="margin-bottom: -10%;">
<div class="col-md-5" style="margin-left: 5%; height:500px;">
<div class="blog-sliderr5" data-aos="fade-down" data-aos-duration="600"  data-aos-easing="ease-in-sine">
  
  
  <div class="video-containerr">
    <iframe width="510" height="180" src="https://www.youtube.com/embed/WtddJJKoGP8" frameborder="0" allowfullscreen></iframe>
</div>
</div>
</div>


<div class="col-md-5">
  <div class="blog-sliderr5" data-aos="fade-down" data-aos-duration="600" data-aos-easing="ease-in-sine">
  
    <div class="spacetoon-quotes">
      <div class="character1">
          <!-- Spacetoon character image -->
          <img src="../../../../assets/images/rimi.png" alt="Spacetoon Character" id="characterImage" width="200" height="200">
      </div>
      <div class="quote">
          <!-- Quote text -->
          <h2>"نسيت الحزن شوقًا للغد الأفضل"</h2>
          <p>ريمي</p>
          <button id="nextQuoteButton" class='start-btn'>Next Quote</button> <!-- Add the "Next Quote" button -->
      </div>
  </div>
  
  </div>
  </div>

</div>

<!--Spacetoon charactere quotes--><!--
<div class="blog-slider5" data-aos="fade-down" data-aos-duration="600" data-aos-easing="ease-in-sine">   
  <div class="spacetoon-quotes">
      <div class="character1">
          <!-- Spacetoon character image --><!--
          <img src="../../../../assets/images/rimi.png" alt="Spacetoon Character" id="characterImage" width="200" height="200">
      </div>
      <div class="quote">
          <!-- Quote text --><!--
          <h2>"نسيت الحزن شوقًا للغد الأفضل"</h2>
          <p>ريمي</p>
          <button id="nextQuoteButton" class='start-btn'>Next Quote</button> <!-- Add the "Next Quote" button --><!--
      </div>
  </div>
</div>


<!--studenty presentation--><!--
<div class="blog-slider5" data-aos="fade-down" data-aos-duration="600" data-aos-easing="ease-in-sine" style="margin-top: 5%;">
  <div class="definition" >
    <div class="content">
<div class="star"></div>
<ul>
  <li><h3>Welcome to the Studenty Game</h3></li>
    <li><p style="font-weight: lighter;">This interactive experience is designed to guide you on a transformative journey of self-discovery, where you'll uncover and harness your unique strengths. Through engaging gameplay and exploration, you'll embark on a remarkable adventure of personal growth and empowerment.</p></li>
    <li><button class="btn btn-secondary">About us</button></li>
</ul>

    

      
      
    
    </div>
  </div>

</div>-->

<!--Top Clubs-->

    <section class="section-plans" id="section-plans">
      <div class="heading-with-image">
      <h2>Clubs</h2>
      <img src="assets/system-outline-161-trending-flat.gif" width="50px" style="margin-top: 10px;" alt="Animated GIF">
    </div><br><br>
    <div class="blog-slider5" data-aos="fade-down" data-aos-duration="600" data-aos-easing="ease-in-sine">
      <div class="row">
        <div class="col-1-of-4">
          <div class="card">
            <div class="card__side card__side--front-1">
              <div class="card__title card__title--1">
				<div class="rounded-image">
					<img src="assets/images/imc.png" alt="Your Image Alt Text">
				</div>
                
                
              </div>

              <div class="card__details">
                <ul>
                  <li><h5>ISAMM Microsoft Club</h5></li>
                  <li>0000</li>
                </ul>
              </div>
            </div>
            <div class="card__side card__side--back card__side--back-1">
              <div class="card__cta">
                <p>A vibrant and inclusive club offering a diverse range of social and recreational activities, fostering connections, and creating memorable experiences for members and guests alike.</p>
                <a  [routerLink]="['/home/clubsdata/details']" class="btn btn--white">Check Profile</a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-1-of-4">
          <div class="card">
            <div class="card__side card__side--front-1">
              <div class="card__title card__title--2">
                <div class="rounded-image">
					<img src="/assets/images/androidESEN.png" alt="Your Image Alt Text">
				</div>
                
                
              </div>

              <div class="card__details">
                <ul>
                  <li><h5>ESEN Android Club</h5></li>
                  <li>0000</li>
                </ul>
              </div>
            </div>
            <div class="card__side card__side--back card__side--back-1">
              <div class="card__cta">
                <p>A vibrant and inclusive club offering a diverse range of social and recreational activities, fostering connections, and creating memorable experiences for members and guests alike.</p>
                <a href="#popup" class="btn btn--white">Check Profile</a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-1-of-4">
          <div class="card">
            <div class="card__side card__side--front-1">
              <div class="card__title card__title--3">
                <div class="rounded-image">
					<img src="/assets/images/enactusZAGH.jpg" alt="Your Image Alt Text">
				</div>
                
                
              </div>

              <div class="card__details">
                <ul>
                  <li><h5>Enactus Zaghouan</h5></li>
                  <li>0000</li>
                </ul>
              </div>
            </div>
            <div class="card__side card__side--back card__side--back-1">
              
              <div class="card__cta">
                <p>A vibrant and inclusive club offering a diverse range of social and recreational activities, fostering connections, and creating memorable experiences for members and guests alike.</p>
                <a href="#popup" class="btn btn--white">Check Profile</a>
              </div>
            </div>
          </div>
        </div>


        
          
        
        
      </div>
      
    </div>
    

    
    </section>
  



  <!--Top Projects-->
  
    <section class="section-plans" id="section-plans">
      <div class="heading-with-image">
      <h2>Projects</h2>
      <img src="assets/system-outline-161-trending-flat.gif" width="50px" style="margin-top: 10px;" alt="Animated GIF">
    </div><br><br>
    <div class="blog-slider5" data-aos="fade-down" data-aos-duration="600" data-aos-easing="ease-in-sine">
      <div class="row">
        <div class="col-1-of-4">
          <div class="card">
            <div class="card__side card__side--front-1">
              <div class="card__title card__title--1">
				<div class="rounded-image">
					<img src="assets/images/question-mark.jpg" alt="Your Image Alt Text">
				</div>
                
                
              </div>

              <div class="card__details">
                <ul>
                  <li><h5>Project 1</h5></li>
                  
                </ul>
              </div>
            </div>
            <div class="card__side card__side--back card__side--back-1">
              <div class="card__cta">
                <p>A vibrant and inclusive club offering a diverse range of social and recreational activities, fostering connections, and creating memorable experiences for members and guests alike.</p>
                <a  [routerLink]="['/home/clubsdata/details']" class="btn btn--white">Check Profile</a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-1-of-4">
          <div class="card">
            <div class="card__side card__side--front-1">
              <div class="card__title card__title--2">
                <div class="rounded-image">
					<img src="assets/images/question-mark.jpg" alt="Your Image Alt Text">
				</div>
                
                
              </div>

              <div class="card__details">
                <ul>
                  <li><h5>Project 2</h5></li>
                  
                </ul>
              </div>
            </div>
            <div class="card__side card__side--back card__side--back-1">
              <div class="card__cta">
                <p>A vibrant and inclusive club offering a diverse range of social and recreational activities, fostering connections, and creating memorable experiences for members and guests alike.</p>
                <a href="#popup" class="btn btn--white">Check Profile</a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-1-of-4">
          <div class="card">
            <div class="card__side card__side--front-1">
              <div class="card__title card__title--3">
                <div class="rounded-image">
					<img src="/assets/images/question-mark.jpg" alt="Your Image Alt Text">
				</div>
                
                
              </div>

              <div class="card__details">
                <ul>
                  <li><h5>Project 3</h5></li>
                  
                </ul>
              </div>
            </div>
            <div class="card__side card__side--back card__side--back-1">
              
              <div class="card__cta">
                <p>A vibrant and inclusive club offering a diverse range of social and recreational activities, fostering connections, and creating memorable experiences for members and guests alike.</p>
                <a href="#popup" class="btn btn--white">Check Profile</a>
              </div>
            </div>
          </div>
        </div>


      </div>

    </div>
    </section>

    <!--EVENTS-->
  
    <section class="section-plans" id="section-plans">
      <div class="heading-with-image">
      <h2>Events</h2>
      <img src="assets/system-outline-161-trending-flat.gif" width="50px" style="margin-top: 10px;" alt="Animated GIF">
    </div><br><br>
    <div class="blog-slider5" data-aos="fade-down" data-aos-duration="600" data-aos-easing="ease-in-sine">
      <div class="row">
        <div class="col-1-of-4">
          <div class="card">
            <div class="card__side card__side--front-1">
              <div class="card__title card__title--1">
				<div class="rounded-image">
					<img src="assets/images/question-mark.jpg" alt="Your Image Alt Text">
				</div>
                
                
              </div>

              <div class="card__details">
                <ul>
                  <li><h5>Event 1</h5></li>
                  
                </ul>
              </div>
            </div>
            <div class="card__side card__side--back card__side--back-1">
              <div class="card__cta">
                <p>A vibrant and inclusive club offering a diverse range of social and recreational activities, fostering connections, and creating memorable experiences for members and guests alike.</p>
                <a  [routerLink]="['/home/clubsdata/details']" class="btn btn--white">Check Profile</a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-1-of-4">
          <div class="card">
            <div class="card__side card__side--front-1">
              <div class="card__title card__title--2">
                <div class="rounded-image">
					<img src="assets/images/question-mark.jpg" alt="Your Image Alt Text">
				</div>
                
                
              </div>

              <div class="card__details">
                <ul>
                  <li><h5>Event 2</h5></li>
                  
                </ul>
              </div>
            </div>
            <div class="card__side card__side--back card__side--back-1">
              <div class="card__cta">
                <p>A vibrant and inclusive club offering a diverse range of social and recreational activities, fostering connections, and creating memorable experiences for members and guests alike.</p>
                <a href="#popup" class="btn btn--white">Check Profile</a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-1-of-4">
          <div class="card">
            <div class="card__side card__side--front-1">
              <div class="card__title card__title--3">
                <div class="rounded-image">
					<img src="/assets/images/question-mark.jpg" alt="Your Image Alt Text">
				</div>
                
                
              </div>

              <div class="card__details">
                <ul>
                  <li><h5>Event 3</h5></li>
                  
                </ul>
              </div>
            </div>
            <div class="card__side card__side--back card__side--back-1">
              
              <div class="card__cta">
                <p>A vibrant and inclusive club offering a diverse range of social and recreational activities, fostering connections, and creating memorable experiences for members and guests alike.</p>
                <a href="#popup" class="btn btn--white">Check Profile</a>
              </div>
            </div>
          </div>
        </div>


       
      </div>

    </div>
    </section>


    <!--OPPORTUNITIES-->
  
    <section class="section-plans" id="section-plans">
      <div class="heading-with-image">
      <h2>Opportunities</h2>
      <img src="assets/system-outline-161-trending-flat.gif" width="50px" style="margin-top: 10px;" alt="Animated GIF">
    </div><br><br>
    <div class="blog-slider5" data-aos="fade-down" data-aos-duration="600" data-aos-easing="ease-in-sine">
      <div class="row">
        <div class="col-1-of-4">
          <div class="card">
            <div class="card__side card__side--front-1">
              <div class="card__title card__title--1">
				<div class="rounded-image">
					<img src="assets/images/question-mark.jpg" alt="Your Image Alt Text">
				</div>
                
                
              </div>

              <div class="card__details">
                <ul>
                  <li><h5>Opportunity 1</h5></li>
                  
                </ul>
              </div>
            </div>
            <div class="card__side card__side--back card__side--back-1">
              <div class="card__cta">
                <p>A vibrant and inclusive club offering a diverse range of social and recreational activities, fostering connections, and creating memorable experiences for members and guests alike.</p>
                <a  [routerLink]="['/home/clubsdata/details']" class="btn btn--white">Check Profile</a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-1-of-4">
          <div class="card">
            <div class="card__side card__side--front-1">
              <div class="card__title card__title--2">
                <div class="rounded-image">
					<img src="assets/images/question-mark.jpg" alt="Your Image Alt Text">
				</div>
                
                
              </div>

              <div class="card__details">
                <ul>
                  <li><h5>Opportunity 2</h5></li>
                  
                </ul>
              </div>
            </div>
            <div class="card__side card__side--back card__side--back-1">
              <div class="card__cta">
                <p>A vibrant and inclusive club offering a diverse range of social and recreational activities, fostering connections, and creating memorable experiences for members and guests alike.</p>
                <a href="#popup" class="btn btn--white">Check Profile</a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-1-of-4">
          <div class="card">
            <div class="card__side card__side--front-1">
              <div class="card__title card__title--3">
                <div class="rounded-image">
					<img src="/assets/images/question-mark.jpg" alt="Your Image Alt Text">
				</div>
                
                
              </div>

              <div class="card__details">
                <ul>
                  <li><h5>Opportunity 3</h5></li>
                  
                </ul>
              </div>
            </div>
            <div class="card__side card__side--back card__side--back-1">
              
              <div class="card__cta">
                <p>A vibrant and inclusive club offering a diverse range of social and recreational activities, fostering connections, and creating memorable experiences for members and guests alike.</p>
                <a href="#popup" class="btn btn--white">Check Profile</a>
              </div>
            </div>
          </div>
        </div>


        
      </div>

    </div>
    </section>
  

  <!--best of social activities for clubs-->
  <section class="section-plans" id="section-plans">
    <div class="heading-with-image">
      <h2>Highlights</h2>
      <img src="assets/system-outline-161-trending-flat.gif" width="50px"  style="margin-top: 10px;" alt="Animated GIF">
    </div><br><br>
  
  <div class="blog-slider5" data-aos="fade-down" data-aos-duration="600" data-aos-easing="ease-in-sine">   
    <!--Social activities section-->
    <div class="scroll-container">
      <div class="card-container" id="card-container">
          <!-- Card 1 -->
          <div class="card" data-id="WtddJJKoGP8">
              <div class="video-container">
                  <iframe width="270" height="180" src="https://www.youtube.com/embed/WtddJJKoGP8" frameborder="0" allowfullscreen></iframe>
              </div>
              <h2>ZigoFiltre X Enactus Tunisia</h2>
              <p>Card description goes here.</p>
          </div>
          <div class="card" data-id="swvnLDVyWiI">
              <div class="video-container">
                  <iframe width="270" height="180" src="https://www.youtube.com/embed/swvnLDVyWiI" frameborder="0" allowfullscreen></iframe>
              </div>
              <h2>GDG Sousse</h2>
              <p>Card description goes here.</p>
          </div>
  
          <div class="card" data-id="06itekcCZOw">
              <div class="video-container">
                  <iframe width="270" height="180" src="https://www.youtube.com/embed/06itekcCZOw" frameborder="0" allowfullscreen></iframe>
              </div>
              <h2>ESEN Android Club</h2>
              <p>Card description goes here.</p>
          </div>
          <div class="card" data-id="dtvVGfqBXSQ">
              <div class="video-container">
                  <iframe width="270" height="180" src="https://www.youtube.com/embed/dtvVGfqBXSQ" frameborder="0" allowfullscreen></iframe>
              </div>
              <h2>AIESEC X TI 3léh</h2>
              <p>Card description goes here.</p>
          </div>
          <div class="card" data-id="VL6b7l_1V1I">
              <div class="video-container">
                  <iframe width="270" height="180" src="https://www.youtube.com/embed/VL6b7l_1V1I" frameborder="0" allowfullscreen></iframe>
              </div>
              <h2>IEEE Day 2019</h2>
              <p>Card description goes here.</p>
          </div>
          <!-- Add more cards with different video URLs -->
      </div>
  </div>
  
  
        </div>
      </section>


    <!--Character floaing section-->
    <div class="character-container">
        <div class="character">
            <!-- Your character video here -->
            <video width="300" height="auto" autoplay loop muted>
                <source src="../../../../assets/images/astro.mp4" type="video/mp4">
                Your browser does not support the video tag.
            </video>
        </div>
        <div class="icon">
            <!-- Your smaller icon here -->
            <img src="../../../../assets/images/studenty.png" alt="Icon" width="80"> <!-- Adjust the width as needed -->
        </div>
        <div class="popover">
            <p class="popover-text" id="closePopover">Leave me alone</p>
        </div>
        <div class="welcome-text">
            <!-- Welcome message -->
            <p id="welcomeMessage">Welcome to our website!</p>
        </div>
    </div>

  </body>
  </html>